<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        ...mapGetters({
            data: 'artistCatgoriesList',
        })
    },

    watch:
    {
        data()
        {
            this.updateData()
        },
    },

    methods:
    {
        fetch()
        {
            this.$store.dispatch('artistCategoryCheck')
            this.$nextTick(() => {
                this.updateData()
            })
        },

        afterUpdateModel(obj)
        {
            this.$store.dispatch('artistCategoryUpdate', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistFetch')
        },

        afterDeleteModel(obj)
        {
            this.$store.dispatch('artistCategoryDelete', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistFetch')
        },

        afterAddModel(obj)
        {
            this.$store.dispatch('artistCategoryNew', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistFetch')
        },

    },

    data()
    {
        return {
            url: '/v1/admin/artistcategories',
            tableName: 'tableArtistCategories',
            emptyModel: { name: null, attachments: [], },
            columns: [ 'id', 'picture', 'name', 'created_at', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('ARTIST.NAME'),
                    picture: this.$t('GENERAL.IMAGE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('ARTIST.ARTIST') }}</span>
            <mv-artist-category-form :model="model" :edit="formEdit" @save="saveForm"></mv-artist-category-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.ARTISTS') }} - {{ $t('MENU.CATEGORIES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <mv-attachment class="attachment-image" v-for="img in props.row.attachments" :key="img.id" :attachment="img">
                        </mv-attachment>
                    </div>
                    <div slot="picture" slot-scope="props">
                        <div v-if="props.row.attachments && props.row.attachments.length > 0">
                            <img :src="props.row.attachments[0].thumbnail_url">
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/ArtistCategories.vue